export function IconLink(props) {
    return (
        <a href={props.href} className={'flex gap-2 items-center transition-color leading-none text-hover-color-site-primary ' + (props.className || '')}>
            {props.icon}
            <div className='border-b border-transparent border-hover-color-site-primary'>{props.value}</div>
        </a>
    )
}